module.exports = __webpack_public_path__ + "img/dashboard_contract_mono_icon.d0ec4e8e.svg";